import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { AlertCircleIcon } from 'lucide-react';
export function Urgency() {
  return <SectionWrapper className="bg-ink text-white text-center py-20" data-id="element-325">
      <div className="inline-flex items-center gap-2 text-coral mb-6" data-id="element-326">
        <AlertCircleIcon className="w-5 h-5" data-id="element-327" />
        <span className="font-sans font-bold uppercase tracking-wider text-sm" data-id="element-328">
          Precio de lanzamiento: $9.99
        </span>
      </div>

      <h2 className="font-sans text-3xl md:text-4xl font-bold mb-8" data-id="element-329">
        Este precio no es permanente.
      </h2>

      <div className="space-y-4 font-sans text-lg text-white/80 max-w-2xl mx-auto font-medium" data-id="element-330">
        <p data-id="element-331">
          Mientras el producto está en etapa de lanzamiento, el acceso está
          disponible a $9.99.
        </p>
        <p data-id="element-332">Cuando termine esta fase, el precio sube a $15,99.</p>
        <p className="font-bold text-white pt-4" data-id="element-333">
          Si estás viendo este precio, todavía está disponible.
        </p>
      </div>
    </SectionWrapper>;
}